import React from 'react';
import QuickButton from 'Douleutaras/components/QuickButton/QuickButton';
import copy from 'Assets/layout/socialIcons/copy.svg';
import instagram from 'Assets/layout/socialIcons/instagram.png';
import tiktok from 'Assets/layout/socialIcons/tiktok.png';
import viber from 'Assets/layout/socialIcons/viber.png';
import whatsApp from 'Assets/layout/socialIcons/WhatsApp.png';
import { useTranslation } from 'react-i18next';
import { copyToClipboard } from 'Douleutaras/utilities/helpers/navigator.helper';
import snackbarSlice, { SnackbarNotificationType } from 'Douleutaras/redux/data/ui/snackbarSlice';
import { useDispatch } from 'react-redux';

import './SocialShare.scss';

interface SocialShareProps {
  shareUrl: string;
  onActionCompleted(): void; // Callback function to close the modal
}

const SocialShare: React.FC<SocialShareProps> = ({ shareUrl, onActionCompleted }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleCopy = () => {
    copyToClipboard(shareUrl);
    dispatch(
      snackbarSlice.actions.addSnackbarNotification({
        type: SnackbarNotificationType.SUCCESS,
        message: t('T.SHARE.LINK-COPIED')
      })
    );
    onActionCompleted();
  };

  const handleViberShare = () => {
    window.open(`viber://forward?text=${encodeURIComponent(shareUrl)}`, '_blank');
    onActionCompleted();
  };

  const handleWhatsAppShare = () => {
    window.open(`whatsapp://send?text=${encodeURIComponent(shareUrl)}`, '_blank');
    onActionCompleted();
  };

  const handleInstagramShare = () => {
    window.open('https://www.instagram.com', '_blank');
    onActionCompleted();
  };

  const handleTikTokShare = () => {
    window.open('https://www.tiktok.com', '_blank');
    onActionCompleted();
  };

  return (
    <div styleName="share-container">
      <QuickButton
        title={t('T.SHARE.COPY')}
        icon={copy}
        onClick={handleCopy}
      />
      <QuickButton
        title={t('T.SHARE.WhatsApp')}
        icon={whatsApp}
        onClick={handleWhatsAppShare}
      />
      <QuickButton
        title={t('T.SHARE.Viber')}
        icon={viber}
        onClick={handleViberShare}
      />
      <QuickButton
        title={t('T.SHARE.Insta')}
        icon={instagram}
        onClick={handleInstagramShare}
      />
      <QuickButton
        title={t('T.SHARE.Tik Tok')}
        icon={tiktok}
        onClick={handleTikTokShare}
      />
    </div>
  );
};

export default SocialShare;
